import * as Inquiry from '../constants/Inquiry';
import axios from 'axios';
import * as SG from '../constants/AppSettings';
import { noticeAdd } from './App'

export function submitInquiry(formData) {
  return dispatch => {
    axios.post(SG.INQUIRY_CREATE_URL, formData, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    }).then(res => {
      dispatch(noticeAdd('お問合わせを送信しました', 'success'))
    }).catch(res => {
      dispatch(noticeAdd('お問合わせの送信に失敗しました','error'))
      })
    
    return {
      type: Inquiry.INQUIRY_CREATE
    }
  }
}




// WEBPACK FOOTER //
// ./src/actions/Inquiry.js